module.exports = __webpack_public_path__ + "img/CU.8388805c.png";